"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GLEAM_STATUS_TYPES = void 0;
var GLEAM_STATUS_TYPES = Object.freeze({
  DEFAULT: 'default',
  INFO: 'info',
  NEW: 'new'
});
exports.GLEAM_STATUS_TYPES = GLEAM_STATUS_TYPES;